import { Signal } from "@angular/core";
import { debounceTime, skip } from 'rxjs/operators';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

/**
 * Debounce a signal and return a signal of the debounced value,
 * @example 
 * query = signal<string>('');
 * queryDebounced = debounceSignal(query, 250, true);
 * @description This function is useful when you want to debounce a signal that emits values frequently,
 * such as when typing in a search input.
 * @param signal - The signal to debounce
 * @param debounceTimeMs - The debounce time in milliseconds (default is 250ms)
 * @param skipFirstEmission - Whether to skip the first emission (default is false)
 * @returns A signal of the debounced value
 */
export function debounceSignal<T>(signal: Signal<T>, debounceTimeMs: number = 250, skipFirstEmission = false) {
  return toSignal(toObservable(signal).pipe(debounceTime(debounceTimeMs), skip(skipFirstEmission ? 1 : 0)));
}

